function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.82 12.174l9.345-9.09a1.098 1.098 0 000-1.58l-.689-.67a1.173 1.173 0 00-1.624 0l-7.848 7.634L3.148.826A1.158 1.158 0 002.336.5a1.16 1.16 0 00-.813.326l-.688.67a1.094 1.094 0 000 1.58l9.354 9.098c.217.21.507.327.815.326.309 0 .599-.115.815-.326z",
  fill: "currentColor"
});

function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 13",
    className: "icon"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMTMiIHZpZXdCb3g9IjAgMCAyMiAxMyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBkPSJNMTEuODIgMTIuMTc0bDkuMzQ1LTkuMDljLjIxNi0uMjEuMzM1LS40OS4zMzUtLjc5IDAtLjI5OS0uMTItLjU4LS4zMzUtLjc5bC0uNjg5LS42N2ExLjE3MyAxLjE3MyAwIDAwLTEuNjI0IDBsLTcuODQ4IDcuNjM0TDMuMTQ4LjgyNkExLjE1OCAxLjE1OCAwIDAwMi4zMzYuNWMtLjMwOCAwLS41OTYuMTE2LS44MTMuMzI2bC0uNjg4LjY3YTEuMDk0IDEuMDk0IDAgMDAwIDEuNThsOS4zNTQgOS4wOThjLjIxNy4yMS41MDcuMzI3LjgxNS4zMjYuMzA5IDAgLjU5OS0uMTE1LjgxNS0uMzI2eiIgZmlsbD0iY3VycmVudENvbG9yIiBmaWxsLXJ1bGU9Im5vbnplcm8iLz4KPC9zdmc+Cg==";
export { SvgArrowDown as ReactComponent };